module.exports = __webpack_public_path__ + "static/media/skill3_pos_es.2ac1dd18.txt";